import React from 'react';
import { styled } from 'styled-components';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { PlayLink } from '../../ClickableComponents/PlayLink';
import { useHeaderColorSet } from './MainNavigation.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const MainNavigationLink = ({
  link,
  isCompact
}) => {
  const analytics = useAnalyticsDispatch();
  const colorSet = useHeaderColorSet();
  return /*#__PURE__*/_jsx("li", {
    "data-testclass": "main-nav-link",
    children: /*#__PURE__*/_jsx(StyledLink, {
      colorSet: colorSet,
      fontSize: isCompact ? {
        mediaQuery: [],
        default: 14
      } : {
        mediaQuery: [],
        default: 18
      },
      fontType: "Bold",
      text: link.title,
      size: isCompact ? 'small' : 'default',
      to: link.path,
      isCompact: isCompact,
      onClick: () => analytics({
        type: 'click-event',
        name: 'MainNavigationClick',
        value1: link.title,
        value2: link.path
      })
    })
  });
};
const StyledLink = styled(PlayLink).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "MainNavigationLink__StyledLink",
  componentId: "sc-2mjwhi-0"
})(["", "{padding:10px 10px;font-size:16px;}padding:", ";"], Viewports.for('small'), ({
  isCompact
}) => isCompact ? '8px 10px' : '14px 16px');